import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { Anchor } from '~lib/frontend/atoms';
import { Margin } from '~lib/frontend/design-system/components/atoms/utils';
import Button from '~lib/frontend/design-system/components/button/Button';
import TrustSegment from '~website/components/atoms/TrustSegment';
import { trackQuoteEvent } from '~website/features/analytics/store/actions';

const StickyFooter: React.FC = () => {
	const dispatch = useDispatch();

	return (
		<StickyWrapper>
			<Button
				as={Anchor}
				// @ts-ignore
				to={'/quote/our-prices/download'}
				$type={'primary'}
				$size={'large'}
				$stretch
				$trailingIcon={'ic_device_iphone'}
				onClick={() => {
					dispatch(trackQuoteEvent({ action: 'sample_prices_download_app_cta_selected' }));
				}}
			>
				{'Download the app'}
			</Button>
			<Margin $marginTop={'large'} />
			<TrustSegment trustProvider={'trustpilot'} />
		</StickyWrapper>
	);
};

const StickyWrapper = styled.div`
	@media (max-width: ${p => p.theme.breakpoints.mobile}) {
		position: fixed;
		bottom: 0;
		left: ${p => p.theme.spacing.large};
		right: ${p => p.theme.spacing.large};
		margin-bottom: ${p => p.theme.spacing.large};
	}
	margin-top: auto;
`;

export default StickyFooter;
